export default __webpack_public_path__ + "static/media/logo-vn.7cc9ac7d.png";